import { ValidationMessage } from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";

type ErrorType = {
  message?: string;
};
type ErrorValueType = {
  value?: ErrorType;
};

type TranslatedValidationMessageProps = {
  error?: ErrorType | ErrorType[] | ErrorValueType;
  translationOptions?: Record<string, unknown>;
};

export function TranslatedValidationMessage({
  error,
  translationOptions = {},
}: TranslatedValidationMessageProps) {
  const { t } = useTranslation();

  if (!error) {
    return null;
  }
  var errorsArray = Array.isArray(error) ? error : [error];

  const renderError = (error: ErrorType | undefined) => {
    if (!error?.message) {
      return null;
    }
    return (
      <ValidationMessage data-color="danger" key={`error-${error.message}`}>
        {t(error.message, translationOptions)}
      </ValidationMessage>
    );
  };

  return (
    <>
      {errorsArray.map((error) => {
        if ("message" in error) {
          return renderError(error as ErrorType);
        }
        if (Array.isArray(error)) {
          return error.map((e) => renderError(e));
        }
        if ("value" in error) {
          return renderError((error as ErrorValueType).value);
        }
        return renderError({
          message: "skjema.feil-ved-validering",
          ...translationOptions,
        });
      })}
    </>
  );
}
